import React from "react";
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";
import cx from "classnames";
import { useTranslation } from "react-i18next";

const FormattedNumberInputS1 = ({
  className,
  label,
  readOnly,
  disabled,
  placeholder,
  size,
  field,
  form: { touched, errors },
  ...props
}) => {
  const classes = cx(
    "form-field",
    touched[field.name] && errors[field.name] && "form-field--error",
    `form-field--${size}`,
    disabled && "form-field--disabled",
    field.value && "form-field--active",
    className
  );

  const { t } = useTranslation("main");

  return (
    <div className={classes}>
      {label && <label className="form-field__label">{label}</label>}
      <div className="input-group">
        <NumberFormat
          className="form-field__input"
          placeholder={placeholder}
          value={field.value}
          onValueChange={({ value }) =>
            field.onChange({ target: { name: field.name, value } })
          }
          thousandSeparator=" "
          allowNegative={false}
          readOnly={readOnly}
          {...props}
        />
        {touched[field.name] && errors[field.name] && (
          <div className="form-field__error">
            <span>{t(errors[field.name])}</span>
          </div>
        )}
      </div>
    </div>
  );
};

FormattedNumberInputS1.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  size: PropTypes.oneOf(["default", "large", "small"]),
};

FormattedNumberInputS1.defaultProps = {
  label: "",
  placeholder: "",
  className: null,
  readOnly: false,
  size: "default",
};

export default FormattedNumberInputS1;
